import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/dashboard/$profileId")({
    component: Outlet,
    beforeLoad: ({ params }) => {
        const profileId = Number(params.profileId);

        if (!Number.isSafeInteger(profileId) || profileId <= 0) {
            throw redirect({
                to: "/$customerId/dashboard",
                params: { customerId: params.customerId },
                replace: true,
            });
        }
    },
    staticData: {
        titleFn: null,
    },
});
